var idioma = $('html').attr('lang');
//datapicker
$('.houdiniForm .hasDatepicker').datepicker({language: idioma});
